 
import React from 'react';

import { BrowserRouter } from '@interstellar/react-app-routing';
import { createRoot } from 'react-dom/client';

import App from './containers/app/App';
import AppConfigContext from './containers/appConfig/AppConfigContext';

const container = document.getElementById('app');

const root = createRoot(container!);

root.render(
  <AppConfigContext.Provider value={(window as any).appConfig}>
    <BrowserRouter basename={process.env.BASE_PATH}>
      <App />
    </BrowserRouter>
  </AppConfigContext.Provider>,
);
